class MegaMenuBuilderSlider {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('[data-mega-menu-builder-slide]'));
    this.dots = Array.from(container.querySelectorAll('[data-mega-menu-builder-dot]'));
    this.currentIndex = 0;
    this.intervalId = null;
    this.duration = Math.max(Number(container.dataset.slideDuration || 5), 1) * 1000;

    if (this.slides.length <= 1) {
      this.dots.forEach((dot) => dot.hidden = true);
      this.showSlide(0);
      return;
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.showSlide(index);
        this.restart();
      });
    });

    this.showSlide(0);
    this.start();
  }

  showSlide(index) {
    this.currentIndex = index;
    this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
    this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  }

  start() {
    this.intervalId = window.setInterval(() => {
      this.showSlide((this.currentIndex + 1) % this.slides.length);
    }, this.duration);
  }

  restart() {
    window.clearInterval(this.intervalId);
    this.start();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mega-menu-builder-slider]').forEach((container) => {
    if (!container.dataset.sliderInitialized) {
      container.dataset.sliderInitialized = 'true';
      new MegaMenuBuilderSlider(container);
    }
  });
});
